export const MAINNET_CHAIN_ID = 43114;

export const switchDefaultTokens = (currentChain: any) => {
  switch (currentChain) {
    case "Avalanche":
      return {
        fromAddress: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        toAddress: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
      };
    case "Solana":
      return {
        fromAddress: "SoNative11111111111111111111111111111111111",
        toAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
      };
    case "Toncoin":
      return {
        fromAddress: "EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c",
        toAddress: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs",
      };
  }
};
